import { render } from "./comparePanel.vue?vue&type=template&id=416b16a8"
import script from "./comparePanel.vue?vue&type=script&lang=js"
export * from "./comparePanel.vue?vue&type=script&lang=js"

import "./comparePanel.vue?vue&type=style&index=0&id=416b16a8&lang=scss"

import exportComponent from "/Users/a/Desktop/app/boyuan_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__